/**
 * Détection client « mobile ou tablette » pour afficher un écran de refus
 * (pas de SSR : exécuté uniquement dans le navigateur).
 */
export function isMobileOrTabletClient() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  if (/iPad/i.test(ua)) return true;
  if (/Macintosh/i.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1) {
    return true;
  }
  if ('ontouchstart' in window && window.matchMedia?.('(max-width: 1180px)')?.matches) return true;
  return false;
}
